'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleElement = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toggleClass = function toggleClass(_ref) {
  var selector = _ref.selector,
      normalizedClassName = _ref.normalizedClassName,
      action = _ref.action;

  if (action === 'toggle') {
    $(selector).toggleClass(normalizedClassName);
  } else if (action === 'add') {
    $(selector).addClass(normalizedClassName);
  } else if (action === 'remove') {
    $(selector).removeClass(normalizedClassName);
  }
};

var toggleElement = exports.toggleElement = function toggleElement(_ref2) {
  var selector = _ref2.selector,
      _ref2$className = _ref2.className,
      className = _ref2$className === undefined ? _Dom2.default.isActive : _ref2$className,
      _ref2$action = _ref2.action,
      action = _ref2$action === undefined ? 'toggle' : _ref2$action,
      clear = _ref2.clear,
      _ref2$animated = _ref2.animated,
      animated = _ref2$animated === undefined ? false : _ref2$animated;

  var normalizedClassName = className[0] === '.' ? className.slice(1) : className;
  var normalizedSelectorString = className[0] !== '.' ? '.' + className : className;
  var impossibleAdd = $(selector).is(normalizedSelectorString) && action === 'add';
  var impossibleRemove = !$(selector).is(normalizedSelectorString) && action === 'remove';

  if (impossibleAdd || impossibleRemove) {
    return Promise.resolve({});
  }

  if (animated) {
    return new Promise(function (resolve) {
      $(selector).one('transitionend', function () {
        return resolve({ selector: selector, className: className, action: action, animated: animated });
      });

      toggleClass({ selector: selector, normalizedClassName: normalizedClassName, action: action });
    });
  }

  if (clear) {
    toggleClass({ selector: clear, normalizedClassName: normalizedClassName, action: 'remove' });
  }

  toggleClass({ selector: selector, normalizedClassName: normalizedClassName, action: action });

  return Promise.resolve({ selector: selector, className: className, action: action, animated: animated });
};

exports.default = {
  toggle: toggleElement
};